import React from 'react';

import { StringParam, useQueryParams } from 'use-query-params';

interface IUseSaveInURL<T> {
  onSave: (data?: T) => void;
  savedData?: T;
}

export const useSaveInURL = <T>(paramName: string): IUseSaveInURL<T> => {
  const [query, setQuery] = useQueryParams({ [paramName]: StringParam });

  const onSave = React.useCallback(
    (data?: T) => {
      const stringFilter = data ? JSON.stringify(data) : null;

      setQuery({ [paramName]: stringFilter });
    },
    [paramName, setQuery],
  );

  const savedData = React.useMemo(() => {
    try {
      if (query?.[paramName]) {
        return JSON.parse(query[paramName]!);
      }
    } catch {
      setQuery({ [paramName]: null });
      // eslint-disable-next-line no-console
      console.warn('Error of parsing query string from url.');
    }
  }, [paramName, query, setQuery]);

  return {
    onSave,
    savedData,
  };
};
